import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListIsOnlineCell } from './charge-point-list-is-online.cell';
import { ChargePointListIsOnlineHeader } from './charge-point-list-is-online.header';

export const ChargePointListIsOnlineColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['isOnline']
> = {
  enableSorting: false,
  header: ChargePointListIsOnlineHeader,
  cell: ChargePointListIsOnlineCell,
  meta: { maxWidth: '60px', width: '40px' },
};
